import { DEBUG } from '../config';

export function toJSNumber(value: undefined): undefined;
export function toJSNumber(value: bigint): number;
export function toJSNumber(value?: bigint): number | undefined;
export function toJSNumber(value?: bigint): number | undefined {
  if (value === undefined) return undefined;

  if (DEBUG && (value < Number.MIN_SAFE_INTEGER || value > Number.MAX_SAFE_INTEGER)) {
    // eslint-disable-next-line no-console
    console.error('Unsafe BigInt conversion', value);
  }

  return Number(value);
}

export function tryParseBigInt(value: string): bigint | undefined {
  try {
    return BigInt(value);
  } catch (error) {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.error('Error parsing BigInt', value, error);
    }
    return undefined;
  }
}

// Deterministic string-to-number hash (djb2 variant), returned as a signed 32-bit integer.
export function stringToNumber(value: string) {
  return value.split('').reduce((prevHash, currentChar) => (
    (((prevHash << 5) - prevHash) + currentChar.charCodeAt(0)) | 0), 0);
}
